import { injectReducer } from '../../store/reducers'
import { resetDialog } from './modules/resetPassword'

export default (store) => ({
  path : 'resetpassword',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const ResetPass = require('./containers/ResetPasswordContainer').default
      const reducer = require('./modules/resetPassword').default

      injectReducer(store, { key: 'resetPass', reducer })
      store.dispatch(resetDialog());
      cb(null, ResetPass)

    }, 'resetPass')
  }
})




// WEBPACK FOOTER //
// ./src/routes/ResetPassword/index.js